import React from "react"
import RecordInvoice from "../../component/record-invoice/record-invoice"

export default function RecordInvoicePage() {
  return <RecordInvoice />
}